import { render, staticRenderFns } from "./youtube-accounts.vue?vue&type=template&id=36551556&scoped=true&"
import script from "./youtube-accounts.vue?vue&type=script&lang=js&"
export * from "./youtube-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36551556",
  null
  
)

export default component.exports